import { I18nComponente } from "@/types/gerais"

export const NovoProfissionali18n: I18nComponente = {
  "pt-BR": {
    dadosDeAcessoResponsabilidades: "dados de acesso e responsabilidades",
    atributosParaAlocacaoDoProfissional: "atributos para alocação do profissional",
    esseProfissionalNaoEstaLigadoUmUsuarioDeAcesso: "este profissional não está ligado a um usuário de acesso",
    adicionarUsuario: "adicionar usuário",
    qualCategoriaProfissionalPertence: "a qual categoria o profissional pertence?",
    categoria: "categoria",
    voltarEditar: "voltar e editar",
    simCancelar: "sim, cancelar",
    editar: "editar",
    voltar: "voltar",
    cancelar: "cancelar",
    criarNovoProfissional: "criar novo profissional",
    cancelarCriacaoDoProfissional: "cancelar criação do profissional?",
    aoCancelarVocePerderaTodasAsInformacoesNaoSalvas: "Ao cancelar você perderá todas as informações não salvas",
    profissionalNaoEncontrado: "profissional não encontrado",
    naoFoiPossivelEncontrarProfissional: "Não foi possível encontrar o profissional",
    erroAoBuscarProfissional: "Erro ao buscar profissional",
    ocorreuUmErroAoBuscarProfissional: "Ocorreu um erro ao buscar o profissional",
    erroAoAlterarFoto: "Erro ao alterar foto",
    ocorreuUmErroAoAlterarFotoDoProfissional: "Ocorreu um erro ao alterar a foto do profissional",
    ocorreuUmErroAoAlterarFotoDoUsuarioDoProfissional: "Ocorreu um erro ao alterar a foto do usuário do profissional",
    profissionalCriado: "profissional criado",
    cadastradoComSucesso: "cadastrado(a) com sucesso!",
    naoFoiPossivelCriarProfissional: "Não foi possível criar o profissional",
    profissionalAtualizado: "profissional atualizado",
    atualizadoComSucesso: "atualizado(a) com sucesso!",
    erroAoTravarPeriodo: "Erro ao travar período",
    porFavorVerifiquePreenchimentoDosCampos: "Por favor, verifique o preenchimento dos campos",
    camposInvalidos: "Campos inválidos",
    preenchaOuCorrijaOsCamposAlertados: "Preencha ou corrija os campos alertados",
    ocorreuUmErroAoAtualizarProfissional: "Ocorreu um erro ao atualizar o profissional"
  },
  "es-CO": {
    dadosDeAcessoResponsabilidades: "datos de acceso y responsabilidades",
    atributosParaAlocacaoDoProfissional: "atributos para la asignación del profesional",
    esseProfissionalNaoEstaLigadoUmUsuarioDeAcesso: "este profesional no está vinculado a un usuario de acceso",
    adicionarUsuario: "agregar usuario",
    qualCategoriaProfissionalPertence: "¿a qué categoría pertenece el profesional?",
    categoria: "categoría",
    voltarEditar: "volver y editar",
    simCancelar: "sí, cancelar",
    editar: "editar",
    voltar: "volver",
    cancelar: "cancelar",
    criarNovoProfissional: "añadir nuevo profesional",
    cancelarCriacaoDoProfissional: "¿cancelar la creación del profesional?",
    aoCancelarVocePerderaTodasAsInformacoesNaoSalvas: "Al cancelar perderás toda la información no guardada",
    profissionalNaoEncontrado: "profesional no encontrado",
    naoFoiPossivelEncontrarProfissional: "No se pudo encontrar el profesional",
    erroAoBuscarProfissional: "Error al buscar profesional",
    ocorreuUmErroAoBuscarProfissional: "Ocurrió un error al buscar el profesional",
    erroAoAlterarFoto: "Error al cambiar foto",
    ocorreuUmErroAoAlterarFotoDoProfissional: "Ocurrió un error al cambiar la foto del profesional",
    ocorreuUmErroAoAlterarFotoDoUsuarioDoProfissional: "Ocurrió un error al cambiar la foto del usuario del profesional",
    profissionalCriado: "profesional creado",
    cadastradoComSucesso: "registrado(a) con éxito!",
    naoFoiPossivelCriarProfissional: "No fue posible añadir el profesional",
    profissionalAtualizado: "profesional actualizado",
    atualizadoComSucesso: "actualizado(a) con éxito!",
    erroAoTravarPeriodo: "Error al congelar período",
    porFavorVerifiquePreenchimentoDosCampos: "Por favor, verifique el llenado de los campos",
    camposInvalidos: "Campos inválidos",
    preenchaOuCorrijaOsCamposAlertados: "Llene o corrija los campos alertados",
    ocorreuUmErroAoAtualizarProfissional: "ocurrió un error al actualizar el profesional"
  }
}
